import moment from 'moment';

const DAYDIFF = (end, start) => {
  const endDate = end || new Date();
  return moment(endDate).diff(moment(start), 'days');
};

export default DAYDIFF;
